/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class AttendanceGridApi {
  async GetStudentAttendance(request : st.GetStaffAttendanceDataRequest) : Promise<st.GetStaffAttendanceDataResponse> {
    return await componentApi.call('st', 'st-attendance-grid', 'AttendanceGridApi', 'GetStudentAttendance', {
      request,
    });
  }
  async SaveSectionConfirmation(request : st.SaveSectionConfirmationRequest) : Promise<st.SaveSectionConfirmationResponse> {
    return await componentApi.call('st', 'st-attendance-grid', 'AttendanceGridApi', 'SaveSectionConfirmation', {
      request,
    });
  }
  async SaveSignature(request : st.SaveSignatureRequest) : Promise<st.SaveSignatureResponse> {
    return await componentApi.call('st', 'st-attendance-grid', 'AttendanceGridApi', 'SaveSignature', {
      request,
    });
  }
  async GetAttendanceCodes() : Promise<st.GetAttendanceCodesResponse> {
    return await componentApi.call('st', 'st-attendance-grid', 'AttendanceGridApi', 'GetAttendanceCodes', {
    });
  }
  async GetFocusDate() : Promise<string> {
    return await componentApi.call('st', 'st-attendance-grid', 'AttendanceGridApi', 'GetFocusDate', {
    });
  }
  async CheckAttendanceVerification(request : st.CheckAttendanceVerificationRequest) : Promise<st.CheckAttendanceVerificationResponse> {
    return await componentApi.call('st', 'st-attendance-grid', 'AttendanceGridApi', 'CheckAttendanceVerification', {
      request,
    });
  }
  async CancelPendingVerification(request : st.CancelPendingVerificationRequest) : Promise<st.CancelPendingVerificationResponse> {
    return await componentApi.call('st', 'st-attendance-grid', 'AttendanceGridApi', 'CancelPendingVerification', {
      request,
    });
  }
  async CheckExistingSignature() : Promise<st.CheckExistingSignatureResponse> {
    return await componentApi.call('st', 'st-attendance-grid', 'AttendanceGridApi', 'CheckExistingSignature', {
    });
  }
  async DownloadAttendanceDocument(request : st.DownloadAttendanceDocumentRequest) : Promise<st.DownloadAttendanceDocumentResponse> {
    return await componentApi.call('st', 'st-attendance-grid', 'AttendanceGridApi', 'DownloadAttendanceDocument', {
      request,
    });
  }
  async SaveAttendanceVerificationDocument(request : st.SaveAttendanceVerificationDocumentRequest) : Promise<st.SaveAttendanceVerificationDocumentResponse> {
    return await componentApi.call('st', 'st-attendance-grid', 'AttendanceGridApi', 'SaveAttendanceVerificationDocument', {
      request,
    });
  }
  async GetDocumentCategories() : Promise<st.GetDocumentCategoriesResponse> {
    return await componentApi.call('st', 'st-attendance-grid', 'AttendanceGridApi', 'GetDocumentCategories', {
    });
  }
}
export default new AttendanceGridApi()
